import { render, staticRenderFns } from "./OwalTitleBar.vue?vue&type=template&id=20bc8510&scoped=true"
import script from "./OwalTitleBar.vue?vue&type=script&lang=js"
export * from "./OwalTitleBar.vue?vue&type=script&lang=js"
import style0 from "./OwalTitleBar.vue?vue&type=style&index=0&id=20bc8510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../owal/js/cameras/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bc8510",
  null
  
)

export default component.exports